import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { FormControlBase } from '@leandredev/common_ng_14';
import { form } from '@leandredev/dcbm-ng-lib';
import { filter } from 'rxjs/operators';

import { SplashScreenService } from '../@fury/services/splash-screen.service';
import { ThemeService } from '../@fury/services/theme.service';
import { AppVersion } from './AppVersion';
import { SidenavService } from './layout/sidenav/sidenav.service';
import { CoreService } from './services/core/core.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  hasBeenConnected: boolean;

  constructor(
    private sidenavService: SidenavService,
    private iconRegistry: MatIconRegistry,
    private renderer: Renderer2,
    private themeService: ThemeService,
    @Inject(DOCUMENT) private document: Document,
    private platform: Platform,
    private route: ActivatedRoute,
    protected splashScreenService: SplashScreenService,
    protected coreService: CoreService
  ) {
    FormControlBase.classes = form;

    console.info(`%c Version: ${AppVersion.appVersion}`, 'background:#ff0000;color:#FFFFFF;font-size:50px');

    this.route.queryParamMap
      .pipe(filter((queryParamMap) => queryParamMap.has('style')))
      .subscribe((queryParamMap) => this.themeService.setStyle(queryParamMap.get('style')));

    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');

    this.themeService.theme$.subscribe((theme) => {
      if (theme[0]) {
        this.renderer.removeClass(this.document.body, theme[0]);
      }

      this.renderer.addClass(this.document.body, theme[1]);
    });

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    this.sidenavService.initNavigationWithData();
  }
}
